import { render, staticRenderFns } from "./AllBatchEntries.vue?vue&type=template&id=674c2f3e&scoped=true&"
import script from "./AllBatchEntries.vue?vue&type=script&lang=js&"
export * from "./AllBatchEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c2f3e",
  null
  
)

export default component.exports